import { createSlice } from "@reduxjs/toolkit";

// Define authentication method constants
export const AUTH_METHODS = {
  FIREBASE: "firebase",
  KALEYRA: "kaleyra",
  OTPLESS: "otpless",
};

const initialState = {
  // Existing properties
  phoneNumber: "",
  otpVerificationId: null,
  otpResult: null,
  countryCode: "+91",

  // Single auth method field
  authMethod: AUTH_METHODS.FIREBASE, // Default to Firebase

  // OTPless auto-read OTP
  otplessAutoReadOTP: null,
};

export const loginOtpSlice = createSlice({
  name: "loginOtp",
  initialState: initialState,
  reducers: {
    // Existing reducers
    updatePhoneNumber(state, action) {
      state.phoneNumber = action.payload;
    },
    updateOtpVerificationId(state, action) {
      state.otpVerificationId = action.payload;
    },
    updateOtpResult(state, action) {
      state.otpResult = action.payload;
    },
    updateCountryCode(state, action) {
      state.countryCode = action.payload;
    },

    // Authentication method reducer
    updateAuthMethod(state, action) {
      state.authMethod = action.payload;
    },

    // OTPless auto-read OTP reducer
    updateOtplessAutoReadOTP(state, action) {
      state.otplessAutoReadOTP = action.payload;
    },

    // Reset OTP data
    resetOTPData(state) {
      state.otplessAutoReadOTP = null;
      state.otpResult = null;
      state.otpVerificationId = null;
      state.authMethod = AUTH_METHODS.FIREBASE;
    },
  },
});

export const {
  // Actions
  updatePhoneNumber,
  updateOtpVerificationId,
  updateOtpResult,
  updateCountryCode,
  updateAuthMethod,
  updateOtplessAutoReadOTP,
  resetOTPData,
} = loginOtpSlice.actions;

export default loginOtpSlice.reducer;
